export const step7 = {
  digitalSignatureList: 'Lista de Assinaturas Digitais',
  signatureTypeUpper: 'MEIO DE ASSINATURA',
  mandatory: 'Campo de preenchimento obrigatório',
  signatureStatus: 'ESTADO',
  owner: 'TOMADOR',
  signatureType: 'Meio de assinatura',
  resendEmail: 'REENVIAR EMAIL',
  email: 'E-mail',
  sendSignature: 'ENVIAR ASSINATURA',
  updateSignatureStatus: 'ATUALIZAR ESTADO ASSINATURA',
  startSignature: 'INICIAR ASSINATURA',
  signature: 'ASSINAR',
  changeConfirm: 'CONFIRMAR ALTERAÇÃO',
  leave: 'Sair',
  sendByEmail: 'ENVIAR POR E-MAIL',
  uploadDocuments: 'Upload de Documentos',
  sendDocuments: 'ENVIAR',
  firstReceipt: 'Pagamento do 1.º Recibo',
  attachmentDocuments: {
    title: 'Anexar documentos',
    file: 'Ficheiro',
    typeFile: 'Tipo de documento',
    addFile: 'ADICIONAR OUTRO DOCUMENTO',
    dropzone: {
      title: 'Solte aqui seu ficheiro',
      description:
        'Insira os Ficheiros a carregar até 10MB, tendo em atenção o seu formato e qualidade (PDF, JPG, TIF, PNG e BMP).',
    },
    errors: {
      invalid: 'Formato inválido, verifique o formato do seu ficheiro.',
    },
    success: 'Documento submetido com sucesso.',
  },
  policyDocumentation: {
    section: 'Documentação da Apólice',
  },
  emissionResult: {
    label: 'RESULTADO DA EMISSÃO',
    policyNumber: 'N.º da Apólice',
    policyState: 'Estado da Apólice',
    receiptNumber: 'N.º do Recibo',
    receiptState: 'Situação do 1.º recibo',
    receiptValue: 'Valor do 1.º Recibo(€)',
  },
  otp: {
    invalidEmail: 'Formato inválido para este campo ex: xxx@xxx.xx',
    invalidPhoneNumber: 'Por favor introduza um valor válido para este campo',
  },
  signatureMessageStatus: {
    pending: 'Pendente de assinatura',
    pendingDigital: 'Pendente de assinatura digital',
    payment: 'Pendente de pagamento',
    signed: 'Assinado',
  },
  receiptMessageStatus: {
    inDebit: 'Em Dívida',
    charged: 'Cobrado',
    offer: 'Oferta',
  },
}
